import React from "react";

interface Props {
  status?: string;
}

const StatusBadge: React.FC<Props> = ({ status }) => {
  const s = String(status || "").toLowerCase();
  const base = "text-xs px-2 py-1 rounded-full border inline-flex";
  if (s === "approved" || s === "assessment_ongoing")
    return (
      <span className={`${base} bg-green-50 border-green-200 text-green-700`}>
        {status}
      </span>
    );
  if (s === "awaiting_assessment")
    return (
      <span className={`${base} bg-blue-50 border-blue-200 text-blue-700`}>
        awaiting assessment
      </span>
    );
  if (s === "submitted" || s === "pending")
    return (
      <span
        className={`${base} bg-yellow-50 border-yellow-200 text-yellow-700`}
      >
        {status}
      </span>
    );
  if (s === "rejected")
    return (
      <span className={`${base} bg-red-50 border-red-200 text-red-700`}>
        {status}
      </span>
    );
  return (
    <span className={`${base} bg-gray-50 border-gray-200 text-gray-700`}>
      {status || "—"}
    </span>
  );
};

export default StatusBadge;
